export const en = {
    idle1: 'An extraordinary lot!',
    idle2: 'Now it is time to bid!',
    idle3: 'Do not miss out on it!',
    idle4: 'Last chance to bid!',
    seconds: '{value} seconds left to bid!',
    fairwarningclose: 'Fair warning! The bidding for this lot is about to end.',
    error: 'We encountered an error. Sorry for the inconvenience and please try again shortly',
    bids: {
        current: 'Current price',
        ask: 'Asking price',
        bid: 'Bid',
        bid_warn: 'FAIR WARNING! Bid',
        highest: 'You are the highest bidder with {value} EUR!',
        sent: 'Your bid of {value} EUR has been sent.',
        wait: 'Wait for the bidding to start!',
        sold: 'Sold!',
        congrats: 'Congratulations!',
        pass: 'Next lot!',
        received: 'Your bid of {value} has been received!',
        confirmation: 'You are about to bid',
        confirmation_info: 'Are you sure you want to bid for the lot?',
        hold: 'Keep holding button to bid...',
        outbid: 'You have been outbid!',
        more: 'or bid more',
        more_mobile: '+',
        is_bidding: 'Sending your bid...',
    },
    account: {
        review: 'Review your account!',
        login: 'Login to bid!',
        your_paddle: 'Your paddle is',
        status_asteptare: 'Pending approval',
        aprobat: 'Account approved',
        neaprobat: 'Unapproved account',
    },
    lots: {
        prev: 'Prev',
        next: 'Next',
        no_results: 'No results for',
        no_more_lots: 'No more lots to show',
        sold: 'Sold',
        pass: 'Passed',
        withdrawn: 'Withdrawn',
        sold_post: 'Sold post-auction',
        open: 'Open for bidding',
        recalled: 'Recalled',
        support: 'Live support at',
        search_lots: 'Search lots'
    },
    lot: {
        recall: 'Recall',
        recalled: 'Recall request has been sent',
        absentee: 'Absentee bid',
        absentee_sent: 'Absentee bid has been sent',
        reminder: 'Bid reminder',
        details: 'Details',
        next: 'Next'
    },
    general: {
        lot: 'Lot',
        est: 'Est',
        sp: 'SP', // 'Starting price',
        close: 'Close',
        deactivate: 'Deactivate',
        cancel: 'Cancel',
        loading: 'Loading',
        standby: 'Stand by! The auction is about to start!',
        break: 'The auction was paused! Please stand by!',
        ended: 'The auction has ended! Thank you for your participation!',
        ended_recall: 'The auction has ended. Unsold lots can still be recalled for:',
        ended_recall_help: 'Open the lots list, select any unsold lot, and send a recall request. Each recall resets the timer to 5 minutes.',
        show_unsold_lots: 'Show unsold lots',
        back_to_current: 'Back to auction\'s current lot',
        room_view: 'Switch to room view',
        standard_view: 'Switch to standard view',
        turn_on_sound: 'Turn on sound',
        turn_off_sound: 'Turn off sound',
        mute_video: 'Mute video',
        unmute_video: 'Unmute video',
        mute_sounds: 'Mute sounds',
        unmute_sounds: 'Unmute sounds',
        audio_announcements_blocked: 'Autoplay was blocked. Turn on sound to play live announcements.',
        audio_announcements_disabled: 'Audio announcements are waiting. Turn on sound to start playback.',
        redirect_home: 'You\'ll be redirected to home page in {seconds} seconds...',
        redirect_old: 'You\'ll be redirected to Artmark Live app in {seconds} seconds...',
        redirect_now: 'Redirect me now!',
        reload_all: 'Application will reload in {seconds} secunde...',
        reload_now: 'Reloading now!',
        welcome: 'Welcome to the Artmark Live auction platform! The auction will begin shortly, according to the timer. We invite you to carefully read the <a href="/en/auction-rules" target="_blank" class="underline">Auction Rules</a> before participating. You can contact us at <a href="mailto:office@artmark.ro" class="underline">office@artmark.ro</a> for clarifications regarding the auction rules or at <a href="mailto:auctions@artmark.ro" class="underline">auctions@artmark.ro</a> for consultancy regarding the lots in the auction. Good luck!',
        welcome2: 'Given the high value of the lots and the security measures required for their handling, several special rules will apply: 1. The auction is co-organized with Maison Maitre Ortica & Associés, Lyon, France, which, on behalf of the consignor’s family, will manage the collection’s proceeds and the transfer of lots to successful bidders. 2. All lots are currently stored in a Romanian bank vault and will not be physically exhibited prior to the auction. The photographs, of necessarily limited quality, were taken in the context of bank storage. The numbers shown in the images refer only to storage arrangements and not to the lot order. The order of sale is that indicated in the official auction catalogue. 3. Winning bids, plus Artmark’s standard buyer’s premium, must be paid strictly within 7 days, in euros, into the special account designated by the co-organizer (also specified on the pro forma invoices): IBAN FR76 1695 8000 0147 6889 6548 417, held at DRFIP Rhône (3-5 Rue de la Charité, 69268 Lyon Cedex 02), BIC: QNTOFRP1XXX. 4. Lots will be released by the depositary bank and may be collected from Artmark headquarters within 3 working days of confirmation by the co-organizer’s bank of full payment in accordance with the invoices.',
        ok: 'Ok',
        contact_1: '<a href="tel:+40 736 381 178" class="underline">+40 736 381 178</a>',
        contact_2: '<a href="tel:+40 758 056 113" class="underline">+40 758 056 113</a>',
    },
    modals: {
        send_offer: 'Place your bid',
        send_offer_details: 'Choose the maximum amount you wish to offer. We will bid on your behalf up to the amount you indicated, without exceeding it',
        send_absentee_bid: 'Send absentee bid',
        maximum_amount: 'Maximum amount',
        bid_more: 'Offer a higher amount',
        bid_more_details: 'Are you sure you want to offer ',
        bid_more_confirmation: 'Place the selected bid',
        recall_title: 'Recall',
        recall_details: 'Are you sura you want to recall the lot {lot}, {description}? We will automatically place bids on your behalf, for ',
        recall_reserve: 'Reserve Price is ',
        recall_starting_prince: 'Starting price is ',
        recall_continue: 'Do you want to continue?',
    },
    messages: {
        lot_announce: 'Lot {lot}',
        lot_open: 'Bidding has started! Offer now for {ask} EUR!',
        lot_open_winner: 'The current price of the lot is {curent} EUR offered by {paddle}',
        lot_reserve: 'The reserve price of {value} EUR is yours!',
        lot_sell_congrats: 'Congratulations! The lot is yours.',
        lot_sell: 'Lot sold!',
        lot_pass: 'Next lot',
        lot_pass_reserve: 'The reserve price was not reached. Next lot',
        lot_reset: 'Lot {lot}',
        bid_win_congrats: 'You won the bid at {value} EUR!',
        bid_win: '{paddle} won the bid at {ask} EUR',
        bid_outbid: 'You have been outbid!',
        price_changed: 'The current price of the lot is {price} EUR',
        ask_changed: 'The asking price is now {ask} EUR',
        ask_spit: 'Additionally, the House grants a reduced step of {ask} EUR.',
        bid_receive: '{paddle} offered {ask} EUR',
        lot_warn: 'Fair warning, last chance...',
        lot_warn_fairwarningclose: 'Fair warning, last chance...',
        lot_warn_once: 'Once...',
        lot_warn_twice: 'Twice...',
        lot_warn_seconds: '{seconds} seconds left...',
        lot_recall: 'The recall of lot {lot} has been requested by {paddle}',
        lot_announce_recall: 'Lot {lot} has been recalled',
        lot_announce_back_to_auction: 'Back to auction\'s current lot'
    },
    timer: {
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds',
    }
}
